/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Icon } from '..';
import { getStarValues } from './rating-stars-service';

import './rating-stars.scss';
/** Star Rating out of 5 stars, shows half stars, component updates only upon mounting */
class RatingStars extends Component {
    constructor(props) {
        super(props);

        this.starValues = getStarValues(props.rating);
        this.click = props.onClick;
    }

    render = () => {
        const Elem = this.click ? 'button' : 'div';
        return (
            <Elem
                className="rating-stars"
                onClick={this.click}
                style={this.click ? { cursor: 'pointer', border: 'none', background: 'none' } : {}}
            >
                {this.starValues.map((value, index) => (
                    <Icon
                        key={`${value}-${index}`}
                        type={value}
                        color="yellow"
                        className="rating-stars-icon"
                    />
                ))}
            </Elem>
        );
    };
}

RatingStars.defaultProps = {
    onClick: () => {},
};

RatingStars.propTypes = {
    onClick: PropTypes.func,
    rating: PropTypes.number.isRequired,
};

export default RatingStars;
